import { Spin } from "antd";
import { Button } from "react-bootstrap";
import { useEffect, useState, useRef } from "react";
import { TranslateString, convertToObjectKeyString } from "Utils/Common";
import { useIntl } from 'react-intl';
import LogsList from "./LogsList";
import HousingCompanyService from "services/services/HousingCompanyService";

const Logs = (props: any) => {
    const [loading, setLoading] = useState<any>(false);
    const [logData, setLogData] = useState<any>();
    const [sort, setSort] = useState(false);
    const [searchData, setSearchData] = useState<any>({ log_for: "", customer_id: "", customer_name: "", loan_data_name: "", is_active: "", reason: "", created_by: "", created_at: "", sort: "asc", sort_by: "" });
    const intl = useIntl();
    const [totalRecords, setTotalRecords] = useState<any>(0);
    const [totalPages, setTotalPages] = useState<any>(0);
    const [pageData, setPageData] = useState<any>({ size: 10, page: 0 });
    const [paginationData, setPaginationData] = useState<any>({ page: 1, pageSize: 10 });


    useEffect(() => {
        getLogList();
    }, [searchData,  pageData]);

    const getLogList = () => {
        setLoading(true);
        let object: any = {};
        object.log_for = searchData?.log_for.replace('-','_') || '';
        object.customer_id = searchData?.customer_id || '';
        object.customer_name = searchData?.customer_name || '';
        object.loan_data_name = searchData?.loan_data_name || '';
        object.is_active = (searchData?.is_active) || '';
        object.created_by = searchData?.created_by || '';
        object.reason = searchData?.reason || '';
        object.created_at = searchData?.created_at || '';
        object.sort = sort ? "desc" : "asc";
        object.sort_by = searchData.sort_by || '';
        object.size = pageData?.size;
        object.page = pageData?.page;


        HousingCompanyService
            .getLogs(object)
            .then((response: any) => {
                if (response?.data?.code === 200) {
                    let responseVal = response?.data?.data;
                    setLogData(responseVal)
                    setTotalPages(response?.data?.total_pages);
                    setTotalRecords(response?.data?.total_records);
                    setPaginationData({ page: 1, pageSize: paginationData.pageSize });
                }
                setLoading(false);
            })
            .catch((err: any) => {
                setLoading(false);
            });
    }

    return (
        <>
            <Spin spinning={loading}>
                <LogsList
                    logData={logData}
                    setSort={setSort}
                    sort={sort}
                    setSearchData={setSearchData}
                    searchData={searchData}
                    totalRecords={totalRecords}
                    totalPages={totalPages}
                    pageData={pageData}
                    paginationData={paginationData}
                    setPaginationData={setPaginationData}
                    setPageData={setPageData}
                />
            </Spin>
           
        </>
    );
};
export default Logs;